import React, { useEffect } from "react";
import StatCard from "../stat-card/StatCard";
import { DashboardContainer, StatsGrid } from "./Dashboard.styled";
import { withRefluxStore } from "../../../../Stores";
import {
  CustomerSucessController,
  ModalConfirm,
  Store__System
} from "@talentbait/shared-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../../../Components/Upload/Upload.styled";
import CampaignsOverviewStore from "../../CampaignsOverviewStore";
import { ActionsCampaignsOverview } from "../../../../Actions/ActionsCampaignsOverview/ActionsCampaignsOverview";
import CtaWidget from "../cta-widget/CtaWidget";
import Actions from "../../../../Actions";
import { BrandKitMessage, BrandKitMessageWrapper } from "../../../Dashboard/Dashboard.styled";
import { getPermissions } from "../../../../Permissions";
import { withRouter } from "react-router-dom";
import { handleNewAssistantFlowFlag } from "../../../../utils/handleNewAssistantFlowFlag";

const Dashboard = ({
  flags,
  history,
  //Store
  organization,
  userProfile,
  activeCampaignCount,
  loadingActiveCampaignCount,
  activeApplicantsCount,
  loadingActiveApplicantsCount
}) => {
  const { t } = useTranslation();
  const { isAgency, hasCompletedBrandkitOnboarding, disableCampaignBooking } = organization || {};
  const { hasPermissionsToCreateCampaigns } = getPermissions(userProfile);

  useEffect(() => {
    if (organization) {
      ActionsCampaignsOverview.getActiveCampaignCount(organization.id);
      ActionsCampaignsOverview.getActiveApplicantsCount(organization.id);
    }
  }, [organization]);

  const getDashboardFlags = (userProfile) => {
    const { employerBranding } = flags;
    const employerBrandingFlag = employerBranding && userProfile.useEmployerBranding !== false;
    return { employerBrandingFlag };
  };

  const redirectBrandkit = () => {
    const { employerBrandingFlag } = getDashboardFlags(userProfile);

    // hasCompletedBrandkitOnboarding is present only on new organizations
    // we need to check false to show the brandkit popup
    const needBrandkit = hasCompletedBrandkitOnboarding === false;
    const requiredBKFF = !isAgency && needBrandkit;

    const showNewAssistantFlow = handleNewAssistantFlowFlag(organization);

    const newAssistantRoute = showNewAssistantFlow && !isAgency ? "/assistant" : "/new-campaign";
    const employerBrandingRoute = employerBrandingFlag ? "/choose-campaign" : newAssistantRoute;

    if (!requiredBKFF) {
      CustomerSucessController.send("Dashboard:CreateCampaign", {
        organizationId: organization.id,
        userId: userProfile.id
      });

      return history.push(employerBrandingRoute);
    }

    CustomerSucessController.send("Dashboard:BrandKitPopup", {
      organizationId: organization.id,
      userId: userProfile.id
    });

    const confirmAction = () => {
      CustomerSucessController.send("Dashboard:BrandKitRedirect", {
        organizationId: organization.id,
        userId: userProfile.id
      });

      Actions.toggleModal("brandKitRequired", false);
      history.push("/settings/brand-kit");
    };

    Actions.toggleModal("brandKitRequired", true, {
      headline: t("Strengthen your brand with a BrandKit"),
      widthVersion: "small",
      view: (
        <ModalConfirm
          showDescription={true}
          labelConfirm={t("Create BrandKit now")}
          description={
            <BrandKitMessageWrapper>
              {t(
                "A professional appearance is the key to the success of your campaigns. Your logo is more than just an image - it represents your company on every platform and attracts targeted attention."
              )}
              <BrandKitMessage>
                <strong>{t("Create your BrandKit now")}</strong>
                {", "}
                {t(
                  "to ensure your logo is displayed where it counts. This increases visibility and trust in your brand."
                )}
              </BrandKitMessage>
            </BrandKitMessageWrapper>
          }
          cancelledAction={() => {
            Actions.toggleModal("brandKitRequired", false);
          }}
          confirmedAction={() => confirmAction()}
        />
      )
    });
  };

  const showActiveApplicants =
    !organization?.isAgency &&
    organization?.campaignGoal === "applicants" &&
    organization?.atsAccess;

  return (
    <DashboardContainer>
      <StatsGrid>
        <StatCard
          title={t("Active Campaigns")}
          value={loadingActiveCampaignCount ? <Spinner /> : activeCampaignCount}
          description={t("See all")}
          redirectTo="/assistant-dashboard"
        />
        {showActiveApplicants && (
          <StatCard
            title={t("Active Applicants")}
            value={loadingActiveApplicantsCount ? <Spinner /> : activeApplicantsCount}
            description={t("See all")}
            redirectTo="https://messenger.talentbait.de/"
          />
        )}
        {hasPermissionsToCreateCampaigns && !disableCampaignBooking && (
          <CtaWidget
            title={t("Create campaign")}
            description={t("Launch your next social campaign now")}
            ctaButtonLabel={t("Create campaign")}
            image={"/images/new-dashboard/campaign-creation.png"}
            // styles
            containerBackgroundColor="var(--primary-dark-600)"
            imageBackgroundColor="var(--primary-dark-500)"
            titleTextColor="var(--primary-white)"
            descriptionTextColor="var(--primary-dark-200)"
            ctaButtonTextColor="var(--primary-dark-600)"
            ctaButtonBackgroundColor="var(--primary-green)"
            onCtaButtonClick={redirectBrandkit}
          />
        )}
      </StatsGrid>
    </DashboardContainer>
  );
};

export default withRouter(
  withRefluxStore(
    Dashboard,
    [CampaignsOverviewStore, Store__System],
    [
      "organization",
      "userProfile",
      "activeCampaignCount",
      "loadingActiveCampaignCount",
      "activeApplicantsCount",
      "loadingActiveApplicantsCount"
    ]
  )
);
